import { QueryClient } from "@tanstack/query-core";
import {Admin, Resource, useTranslate} from "react-admin";

import CustomLayout from "./components/common/CustomLayout";
import dataProvider from "./services/dataProvider";
import { i18nProvider } from "./services/i18n/i18nProvider";
import RulesList from "./components/rules/RulesList";
import RulesShow from "./components/rules/RulesShow";
import RulesCreate from "./components/rules/RulesCreate";
import RulesEdit from "./components/rules/RulesEdit";
import { BrowserRouter } from "react-router-dom";
import RulesDeemedSupplierList from "./components/rulesDeemedSupplier/RulesDeemedSupplierList";
import RuleDeemedSupplierShow from "./components/rulesDeemedSupplier/RuleDeemedSupplierShow";
import RuleDeemedSupplierCreate from "./components/rulesDeemedSupplier/RuleDeemedSupplierCreate";
import RuleDeemedSupplierEdit from "./components/rulesDeemedSupplier/RuleDeemedSupplierEdit";
import { authProvider } from "./services/auth/authProvider";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

const App = () => {
  const translate = useTranslate();
  const auth0Provider = authProvider();

    return (
    <BrowserRouter>
      <Admin
        disableTelemetry
        dataProvider={dataProvider}
        queryClient={queryClient}
        i18nProvider={i18nProvider}
        layout={CustomLayout}
        authProvider={auth0Provider}
      >
        <Resource
          name="rules"
          options={{ label: translate("rules.menu") }}
          list={RulesList}
          create={RulesCreate}
          show={RulesShow}
          edit={RulesEdit}
        />
        <Resource
          name="rulesDeemedSupplier"
          options={{ label: translate("rulesDeemedSupplier.menu") }}
          list={RulesDeemedSupplierList}
          show={RuleDeemedSupplierShow}
          create={RuleDeemedSupplierCreate}
          edit={RuleDeemedSupplierEdit}
        />
      </Admin>
    </BrowserRouter>
  );
};

export default App;
